import { render } from "./info-page.vue?vue&type=template&id=577fc132&scoped=true"
import script from "./info-page.vue?vue&type=script&lang=js"
export * from "./info-page.vue?vue&type=script&lang=js"

import "./info-page.vue?vue&type=style&index=0&id=577fc132&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-577fc132"]])

export default __exports__